<template>
  <zj-layout-container
    class="user-layout"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
    <div class="zj-layout-left">
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">LED屏列表</div>
          <el-input
            v-model="filterText"
            placeholder="请输入LED名称"
            class="nav-tree-filter"
          ></el-input>
          <div class="nav-tree-content">
            <el-tree
              style="height:100%;"
              default-expand-all="true"
              v-loading="loading"
              :element-loading-text="loadingText"
              @node-click="nodeClick"
              :data="Lednodes"
              node-key="ID"
              :props="defaultProps"
              :filter-node-method="filterNode"
              class="zj-demo-player-tree-device-tree"
              ref="Ledtree"
            ></el-tree>
          </div>
        </zj-layout-header>
      </zj-layout-container>
    </div>
    <div class="zj-layout-right">
      <zj-layout-container>
        <zj-layout-main>
          <div class="sendPlan">
            <el-transfer
              :data="ledEnableLayout"
              :props="{ key: 'ID', label: 'Name' }"
              :titles="titles"
              :button-texts="['《', '》']"
              v-model="Transvalue"
              :render-content="renderFunc"
              @change="handleChange"
              @left-check-change="handeleLeftChanage"
              target-order="push"
              style="width:100%;height:100%"
            ></el-transfer>
          </div>
        </zj-layout-main>
        <zj-layout-footer>
          <el-form>
            <el-form-item class="right">
              <el-button type="primary" @click="saveForm()">上屏</el-button>
            </el-form-item>
          </el-form>
        </zj-layout-footer>
      </zj-layout-container>
    </div>
  </zj-layout-container>
</template>
<script>
import ZJApp from "../../../../../app";
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../apis";
// eslint-disable-next-line no-unused-vars
import $ from "jquery";
export default {
  name: "LEDSendPlanManagerView",
  controller: "UI",
  action: "LEDSendPlanManagerView",
  data() {
    return {
      num: 1,
      filterText: "",
      loading: false,
      loadingText: "",
      titles: ["可用版式", "已选择版式（上屏只可选择一种版式）"],
      Lednodes: [],
      ledAllLayout: [], //存储所有可用版式列表
      ledEnableLayout: [], // 可用的版式列表
      ledCheckedLayout: [],
      Transvalue: [],
      CurrentPlan: null,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.Ledtree.filter(val);
    },
  },
  created() {
    this.search();
  },
  mounted() {
    this.getLedLayout();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    search() {
      let that = this;
      new MyApis.TranResourcesApi()
        .GetLedEquipmentList({})
        .then((r) => {
          r = r.data.Data;
          this.Lednodes = that.convertToTreeNodesfunction(r);
        })
        .catch((e) => {
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索Led失败！",
            type: "error",
          });
        });
    },
    convertToTreeNodesfunction(list) {
      var result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        var region = {
          ID: regionData.ID,
          label: regionData.NAME_EQT,
          LedInfo: regionData,
        };
        result.push(region);
      }
      let arr = [
        {
          ID: 0,
          label: "LED屏列表",
          children: result,
        },
      ];
      return arr;
    },
    //获取所有的版式
    getLedLayout() {
      new MyApis.LedgetApi()
        .GetLedLayoutList({})
        .then((r) => {
          r = r.data.Data;
          if (r.length > 0) {
            r.forEach((item) => {
              item.Interval = 0;
              item.Checked = false;
            });
            this.ledAllLayout = r;
            
            this.getEnableLayout()
          }
        })
        .catch((e) => {
          this.$message({
            message: e.RspMsg ? e.RspMsg : "搜索版式失败！",
            type: "error",
          });
        });
    },
    nodeClick: function(data, node) {
      if (node.level == 2) {
        this.getEnableLayout()
        this.getCheckedLedLayout(data.ID);
      }
    },
    getCheckedLedLayout(id) {
      this.loading = true;
      this.loadingText = "加载中";
      new MyApis.TranResourcesApi()
        .FindLedPlan({
          id: id,
        })
        .then((r) => {
          r = r.data.Data;
          var checkedvalue = [];
          if (r.length > 0) {
            var layouts = r[0].ItemList;
            this.CurrentPlan = r[0];
            if (layouts.length > 0) {
              layouts.forEach((item) => {
                checkedvalue.push({
                  LayoutID: item.LayoutID,
                  Interval: item.Interval,
                });
              });
            }
          } else {
            this.CurrentPlan = null;
          }
          var transchecked = [];
          this.ledEnableLayout.forEach((layout) => {
            layout.Interval = 0;
            layout.Checked = false;
            checkedvalue.forEach((checkedvalue) => {
              if (checkedvalue.LayoutID == layout.ID) {
                layout.Interval = checkedvalue.Interval;
                layout.Checked = true;
                transchecked.push(checkedvalue.LayoutID);
              }
            });
          });

          this.Transvalue = transchecked;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.$message({
            message: e.RspMsg ? e.RspMsg : "搜索版式失败！",
            type: "error",
          });
        });
    },
    ///版式选中改变
    handleChange(value, direction, movedKeys) {
      if (direction == "right") {
        this.SetInterval(movedKeys, true);
      } else {
        this.SetInterval(movedKeys, false);
      }
    },
    //左侧被选中时
    handeleLeftChanage(keys) {
      if (keys.length > 0) {
        var selectednode = this.$refs.Ledtree.getCurrentNode();
        if (!selectednode) {
          this.errmsg("请选择LED");
        }
      }
    },
    SetInterval(keys, checkbool) {
      keys.forEach((item) => {
        this.ledAllLayout.forEach((bs) => {
          if (item == bs.ID) {
            bs.Checked = checkbool;
            if (!bs.Checked) {
              bs.Interval = 0;
            }
          }
        });
      });
    },
    renderFunc(h, option) {
      if (!option.Checked) {
        return <span>{option.Name}</span>;
      } else {
        return (
          <div>
            <div class="divinline">
              <span>{option.Name}</span>
            </div>
            <el-input class="InputTime" v-model={option.Interval}></el-input>
          </div>
        );
      }
    },
    GetCheckedLayouts() {
      var CheckedLayouts = [];
      this.ledEnableLayout.forEach((layout) => {
        this.Transvalue.forEach((item) => {
          if (layout.ID == item) {
            CheckedLayouts.push(layout);
          }
        });
      });
      return CheckedLayouts;
    },
    saveForm() {
      var selectednode = this.$refs.Ledtree.getCurrentNode();
      if (!selectednode) {
        this.errmsg("请选择LED");
        return;
      }
      var layouts = this.GetCheckedLayouts();
      if (layouts.length == 0) {
        this.errmsg("请配置LED版式与轮播时间");
        return;
      }
      if (layouts.length > 1) {
        this.errmsg("上屏只能选择一种LED版式");
        return;
      }
      if (layouts.length == 1) {
        let Interval = parseFloat(layouts[0].Interval);
        if (Interval <= 0) {
          this.errmsg("请填写上屏的播放时长");
          return;
        }
      }
      if (!this.CurrentPlan) {
        this.CurrentPlan = {
          ID: ZJApp.ZJUtils.uuid(),
          ScreenID: selectednode.ID,
          Flags: "current",
          CreateTime: new Date(),
          Creater: ZJApp.ZJUser.current.UserName,
          Validity: 1,
          Extends1: "",
          Extends2: "",
          Extends3: 0.0,
          ItemList: [],
        };
      } else {
        this.CurrentPlan.ModifiyTime = new Date();
        this.CurrentPlan.Modifier = ZJApp.ZJUser.current.UserName;
      }
      var itemlist = [];
      var list = this.CurrentPlan.ItemList;
      layouts.forEach((layout, index) => {
        var obj = {
          CreateTime: new Date(),
          Creater: ZJApp.ZJUser.current.UserName,
          Extends1: "",
          Extends2: "",
          Extends3: 0,
          ID: ZJApp.ZJUtils.uuid(),
          Interval: layout.Interval,
          LayoutID: layout.ID,
          PlanID: this.CurrentPlan.ID,
          ScreenID: this.CurrentPlan.ScreenID,
          Seq: index + 1,
          Validity: 1,
        };
        list.forEach((item) => {
          if (item.LayoutID == layout.ID) {
            obj.ID = item.ID;
            obj.ModifiyTime = new Date();
            obj.Modifier = ZJApp.ZJUser.current.UserName;
          }
        });
        itemlist.push(obj);
      });
      this.CurrentPlan.ItemList = itemlist;
      //console.log(this.CurrentPlan);
      this.SaveLedPlan();
    },
    SaveLedPlan() {
      this.loading = true;
      this.loadingText = "上屏中";
      if (this.CurrentPlan) {
        new MyApis.TranResourcesApi()
          .SendLedUpMessage(this.CurrentPlan)
          .then((r) => {
            r = r.data.Data;
            console.log("上屏结果");
            console.log(r);
            if (r) {
              this.$message({
                message: "上屏成功",
                type: "success",
              });
            }
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            this.$message({
              message: e.RspMsg ? e.RspMsg : "上屏失败",
              type: "error",
            });
          });
      }
    },
    // 获取可用版式
    getEnableLayout() {
      let ledEnableLayout = [];
      var selectednode = this.$refs.Ledtree.getCurrentNode();
      if (selectednode) {
        let ledInfo = selectednode.LedInfo
        this.ledAllLayout.forEach((layout) => {
          if (layout.ColorType == ledInfo.COLOR_TPLEQT && layout.Width == ledInfo.LEN_TPLEQT && layout.Height == ledInfo.WIDTH_TPLEQT) {
            ledEnableLayout.push(layout)
          }
        })
      }
      this.ledEnableLayout = ledEnableLayout
    }
  },
};
</script>
<style lang="scss">
.sendPlan {
  width: 90%;
  height: 90%;
  margin: 5% auto;
  .el-transfer-panel {
    height: 100%;
    width: 38%;
    border: none;
    background: none;
  }
  .el-transfer-panel .el-transfer-panel__body {
    height: 100%;
    background: rgba(12, 58, 122, 0.3);
    height: 90%;
    margin-top: 1rem;
  }
  .el-transfer-panel .el-transfer-panel__header {
    border-bottom: 1px dashed #0ec0fe;
    height: 5rem;
    color: #00bcfe;
  }
  .el-transfer-panel
    .el-transfer-panel__header
    .el-checkbox
    .el-checkbox__label {
    color: #00bcfe;
    margin-left: -2rem;
  }
  .el-transfer-panel
    .el-transfer-panel__header
    .el-checkbox
    .el-checkbox__input {
    display: none;
  }
  .el-transfer-panel
    .el-transfer-panel__header
    .el-checkbox
    .el-checkbox__label
    span {
    display: none;
  }
  .el-transfer__button .el-icon-arrow-left {
    display: none;
    color: #00bcfe;
  }
  .el-transfer__button .el-icon-arrow-right {
    display: none;
    color: #00bcfe;
  }
  .el-transfer__buttons span {
    color: #00bcfe;
  }
  .el-button--primary.is-disabled,
  .el-button--primary.is-disabled:hover,
  .el-button--primary.is-disabled:focus,
  .el-button--primary.is-disabled:active {
    background: none;
    border-color: #00bcfe;
  }
  .el-transfer-panel__list {
    height: 100%;
  }
  .el-transfer-panel__item.el-checkbox {
    height: 5rem;
    margin: 0;
  }
  .el-transfer-panel__item.el-checkbox .el-checkbox__label span {
    font-size: 2rem;
  }
  .el-transfer-panel__item .el-checkbox__input {
    top: 5px;
  }
}

.divinline {
  display: inline-block;
  width: 18rem;
}
.InputTime {
  width: 10rem;
  right: 1rem;
  position: absolute;
}
</style>
